export default {
  geolocation: {
    lat: '48.2082',
    lng: '16.3738',
    label: '1010 Vienna',
  },
  price_rules: {
    grouping: '.',
    decimal: ',',
  },
}
